import type { JSX } from 'react';

interface LoadingStateProps {
  label?: string;
}

export function LoadingState({ label = 'Caricamento…' }: LoadingStateProps): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12 text-text-secondary">
      <div
        className="h-10 w-10 animate-spin rounded-full border-2 border-primary-600 border-t-transparent"
        aria-hidden
      />
      <p className="text-sm font-medium">{label}</p>
    </div>
  );
}
